module.exports = __webpack_public_path__ + "static/img/guidance6.b720c53f.webp";